<template>
  <div
    class="sli-cell sli-cell--compact sli-cell--year"
  >
    <label
      class="sli-cell__label"
      :for="inputId"
    >{{ label }}</label>
    <div
      class="sli-year"
      :class="{ 'is-open': open }"
    >
      <input
        :id="inputId"
        :value="value"
        type="text"
        inputmode="numeric"
        maxlength="4"
        size="4"
        autocomplete="off"
        placeholder="سنة"
        :disabled="disabled"
        class="sli-cell__input sli-year__input"
        @input="onType"
        @focus="open = !disabled"
      >
      <button
        type="button"
        class="sli-year__toggle"
        :disabled="disabled"
        :aria-expanded="open ? 'true' : 'false'"
        :aria-label="label"
        @click="open = !disabled && !open"
      >
        <feather-icon
          icon="ChevronDownIcon"
          size="14"
        />
      </button>
      <ul
        v-if="open"
        class="sli-year__list"
        role="listbox"
      >
        <li
          v-for="year in years"
          :key="year"
          role="option"
          :class="{ 'is-active': String(year) === String(value) }"
          @mousedown.prevent="pick(year)"
        >
          {{ year }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliYearCombo',
  props: {
    value: { type: [String, Number], default: '' },
    label: { type: String, required: true },
    inputId: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { open: false }
  },
  computed: {
    years() {
      const max = new Date().getFullYear() + 1
      const list = []
      for (let year = max; year >= 1800; year -= 1) list.push(year)
      return list
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
  },
  methods: {
    onType(event) {
      const next = String(event.target.value || '').replace(/\D/g, '').slice(0, 4)
      this.$emit('input', next)
    },
    pick(year) {
      this.$emit('input', String(year))
      this.open = false
    },
    onDocClick(event) {
      if (!this.$el.contains(event.target)) this.open = false
    },
  },
}
</script>
